import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SKIP_BUTTON: `${cleanedFilename(__filename)}-skip-button`,
  NEXT_BUTTON: `${cleanedFilename(__filename)}-next-button`,
};
